import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Segment’s composable platform is open, easy to use, and integrated with all your favorite applications`,
  featureList: [
    {
      heading: `Open, flexible and scalable`,
      description: [
        {
          paragraph: `Segment’s open, flexible, scalable architecture enables engineers to preserve choice in building out their tech stack.`,
        },
        {
          paragraph: `Segment’s customer data platform integrates with a wide variety of systems—including data warehouses and SaaS applications—ensuring maximum compatibility both now and as your business grows.`,
        },
      ],
    },
    {
      heading: `Easily grow your business`,
      description: [
        {
          paragraph: `Segment’s approach has made it easy for thousands of companies worldwide to save time and resources by not having to cobble together immature tools and maintain what amounts to a bespoke CDP, enabling them to concentrate on more strategic initiatives for their business.`,
        },
      ],
    },
    {
      heading: `Integrated with hundred of applications`,
      description: [
        {
          paragraph: `Segment’s pre-built, high-quality connectors and easy to use tools accelerate implementation times and simplify on-going management, significantly lightening the load on data teams.`,
        },
        {
          paragraph: `Segment’s catalog of ${process.env.INTEGRATION_COUNT}+ pre-built integrations save companies significant time and effort connecting Segment into their tech stack with the flexibility to easily onboard new applications.`,
        },
      ],
    },
  ],
}

const ComposablePlatform = () => (
  <StyledSectionBase variant="centered">
    <Section.Copy>
      <CopyTextBase centered={true}>
        <StyledHeading tag="h2">{copy.heading}</StyledHeading>
      </CopyTextBase>
    </Section.Copy>
    <Section.Contents>
      <StyledColumnTrack columns={1} overrides={{ md: 3 }}>
        {copy.featureList.map(({ heading, description }) => (
          <CopyTextBase key={heading}>
            <CopyText.Heading variant="h4">{heading}</CopyText.Heading>
            {description.map((text, index) => (
              <CopyText.Description
                key={index}
                tag="p"
                variant="pMedium"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(text.paragraph, { allowedTags: [`a`] }),
                }}
              />
            ))}
          </CopyTextBase>
        ))}
      </StyledColumnTrack>
    </Section.Contents>
  </StyledSectionBase>
)

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0px;
    row-gap: 20px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      row-gap: 60px;
    }
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
  column-gap: 48px;
`

const StyledHeading = styled(CopyText.Heading)`
  text-align: start;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    text-align: center;
  }
`

export default ComposablePlatform
